function Strategy(strategyId, funds) {
  if ([null, undefined].includes(strategyId)) return [];
  return (strategyId.match(/\d+EE\d{10}/g) || []).map(function (match) {
    const isin = match.substring(match.length - 12, match.length)
    return {
      isin: isin,
      fund: funds[isin],
      percentage: parseInt(match.replace(isin, ''), 10)
    }
  }).filter(function(fund) {
    return fund.percentage > 0
  });
}